import { refreshToken } from '../middlewares/renew-ks';
import { getKsRefreshDeferred } from '../rhino/phoenix/network/deferRefreshKs';

export function refreshKs() {
  refreshToken();

  return getKsRefreshDeferred();
}
